import { render, staticRenderFns } from "./edit-wastetype.vue?vue&type=template&id=07647136&"
import script from "./edit-wastetype.vue?vue&type=script&lang=ts&"
export * from "./edit-wastetype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-wastetype.vue"
export default component.exports